module.exports = __webpack_public_path__ + "static/img/Common 1 - Cascading edition.70f1e10.png";